"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeExcessOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var TrustPilotAndDefaqtoWidget_1 = require("./TrustPilotAndDefaqtoWidget");
var AnnualHomeExcessOutput = /** @class */ (function (_super) {
    __extends(AnnualHomeExcessOutput, _super);
    function AnnualHomeExcessOutput(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeExcessOutput.prototype.render = function () {
        var policyHolder = this.props.interaction.policyHolder;
        var buildings = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "BUILDINGS_LIMIT", this.props.interaction);
        var contents = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "CONTENTS_LIMIT", this.props.interaction);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "home-excess-panel" },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("p", { className: "mb-0 font-weight-bold" }, this.getCoverWording()),
                        React.createElement("p", { className: "mb-0" },
                            React.createElement("span", { className: "font-weight-bold" },
                                policyHolder.firstName,
                                " ",
                                policyHolder.lastName),
                            " (policyholder)"),
                        React.createElement("p", { className: "mb-0" }, policyHolder.address.fullAddress),
                        React.createElement("p", { className: "mb-0" },
                            React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(buildings)),
                            " Buildings"),
                        React.createElement("p", { className: "mb-0" },
                            React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(contents)),
                            " Contents")))),
            React.createElement("p", { className: "font-weight-bold mb-0 mt-4" }, "You can select your cover level below"),
            React.createElement("p", null,
                "We\u2019ve been given the prestigious Defaqto 5 Star Rating for our ",
                React.createElement("span", { className: "font-weight-bold" }, "Allianz Silver "),
                " and ",
                React.createElement("span", { className: "font-weight-bold" }, "Allianz Gold "),
                " insurance."),
            React.createElement(TrustPilotAndDefaqtoWidget_1.TrustPilotAndDefaqtoWidget, null)));
    };
    AnnualHomeExcessOutput.prototype.getCoverWording = function () {
        var coverTier = this.props.interaction.coverTier;
        if (coverTier === services_1.BRONZE_TIER) {
            return "Allianz Bronze Cover";
        }
        else if (coverTier === services_1.SILVER_TIER) {
            return "Allianz Silver Cover";
        }
        else if (coverTier === services_1.GOLD_TIER) {
            return "Allianz Gold Cover";
        }
        return "";
    };
    return AnnualHomeExcessOutput;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeExcessOutput = AnnualHomeExcessOutput;
//# sourceMappingURL=AnnualHomeExcessOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeExcessOutput.js
// module id = 3700
// module chunks = 0